export default {
    'please-select-a-team': 'رجاءً اختر فريق'
}